import { React, useState } from 'react';
import { showToast } from '../../../Utils';
import { apiCall } from '../../../api/Interactor';
import { NavLink, useNavigate } from 'react-router-dom';

export default function ForgotPassword(props) {

    const navigate = useNavigate();

    let [email, setEmail] = useState("");

    const callPostForgotPassword = () => {
        apiCall(
            "POST", process.env.REACT_APP_USER_FORGOT_PASSWORD,
            {
                "email": email
            },
            (response) => {
                console.log(response)
                showToast("Success", "Success", response.data.meta.message)
                setTimeout(() => {
                    navigate('/login');
                }, 2000)
            },
            (message) => {
                showToast("Error", "Failed", message)
            }
        )
    }

    return (
        <main className="flex-1 flex-col px-10 py-12">
            <div className="flex flex-col text-gray-600 space-y-5">
                <div className="text-center pb-4">
                    <img src="/logo_fityuk.webp" width={240} className="mx-auto" />
                    <div className="mt-8">
                        <h3 className="text-gray-800 text-xl font-semibold">Forgot your password</h3>
                    </div>
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        callPostForgotPassword();
                    }}
                    className="space-y-5"
                >
                    <div>
                        <label className="font-medium">
                            Email
                        </label>
                        <input
                            onChange={(e) => { setEmail(e.target.value) }}
                            value={email}
                            type="email"
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div></div>
                    <button
                        className="w-full px-4 py-2 text-white font-medium bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-600 rounded-lg duration-150"
                    >
                        Forgot Password
                    </button>
                </form>
                <div></div>
                <p className="text-center">Try login again? <NavLink
                    to="/login"
                    className="font-medium text-indigo-600 hover:text-indigo-500">
                    Login
                </NavLink></p>
            </div>
        </main>
    );
}